import { Bin } from 'chezy-inventory-backend/bin/database/types/Bin'

export type BinWithChildren = Bin & { children?: BinWithChildren[] }

export const mkBinHeirarchy = (bins: Bin[], parent?: string | null): BinWithChildren[] => {
  const binsAtLevel = bins.filter((b) => b.parent_id === (parent ?? null))
  if (binsAtLevel.length === 0) {
    return []
  }
  return binsAtLevel.map((bin) => ({ ...bin, children: mkBinHeirarchy(bins, bin.id) } as BinWithChildren))
}
